





































































import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import TimepickerComponent from "@/components/packages/timepicker/TimepickerComponent.vue";
import DatepickerComponent from "@/components/packages/datepicker/DatepickerComponent.vue";
import InCategoryTopMenuComponent from "@/components/layout/InCategoryTopMenuComponent.vue";
import { ShowDuration } from "@/typescript/models/sensor/types";
import { DisplayTime } from "@/typescript/packages/timepicker/types";
import { DatepickerElement } from "@/typescript/packages/datepicker/types";
export { DisplayTime, DatepickerElement, ShowDuration };

@Component({
  components: {
    TimepickerComponent,
    DatepickerComponent,
    InCategoryTopMenuComponent
  }
})
export default class TempGraphMenuComponent extends Vue {
  @Prop({
    default: false
  })
  showDelete!: boolean;

  @Prop({
    default: true
  })
  enabled!: boolean;

  @Prop()
  currentDate!: string;

  @Prop()
  selectedDateUnit!: "day" | "week" | "month";

  @Prop()
  selectedDayTimeFrom!: DisplayTime;

  @Prop()
  selectedDayTimeTo!: DisplayTime;

  @Watch("enabled")
  onEnabledChange(value: boolean) {
    this.internalEnabled = value;
  }

  $refs!: {
    datepicker: DatepickerElement;
  };

  dateUnits = [
    { value: "month", name: "月" },
    { value: "week", name: "週" },
    { value: "day", name: "日" }
  ];

  internalEnabled = this.enabled;

  timepickerWidth: string = "82px";
  fromTime: DisplayTime = {
    HH: "00",
    mm: "00"
  };
  toTime: DisplayTime = {
    HH: "00",
    mm: "00"
  };

  @Emit()
  change(value: ShowDuration): ShowDuration {
    return value;
  }

  @Emit()
  delete() {}

  @Emit()
  downloadCsv(event) {
    return event;
  }

  @Watch("startEndTime")
  onTimeChange(newVal: ShowDuration) {
    this.change(newVal);
  }

  get calenderIcon(): string {
    return "/images/icons/btn_common_calendar.png";
  }

  openCalendar() {
    if (this.internalEnabled) {
      if (!this.$refs.datepicker) return;
      this.$refs.datepicker.showCalendar();
    }
  }

  @Emit()
  changeDate(value: string) {
    return value;
  }

  @Emit()
  changeDateUnit(value: "day" | "week" | "month") {
    return value;
  }

  @Emit()
  changeFrom(value: DisplayTime) {
    return value;
  }

  @Emit()
  changeTo(value: DisplayTime) {
    return value;
  }

  clickDelete() {
    this.delete();
  }
}
